// Logos
// 1st Prize
import Award_1_Prize_1x from "./../assets/AwardsPage/Logos/Award_1_Prize/Award_1_Prize_1x.webp";
import Award_1_Prize_2x from "./../assets/AwardsPage/Logos/Award_1_Prize/Award_1_Prize_2x.webp";
import Award_1_Prize_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_1_Prize/Award_1_Prize_1x.webp";
import Award_1_Prize_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_1_Prize/Award_1_Prize_2x.webp";

// Best Employee
import Award_Best_Employee_1x from "./../assets/AwardsPage/Logos/Award_Best_Employee/Award_Best_Employee_1x.webp";
import Award_Best_Employee_2x from "./../assets/AwardsPage/Logos/Award_Best_Employee/Award_Best_Employee_2x.webp";
import Award_Best_Employee_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Best_Employee/Award_Best_Employee_1x.webp";
import Award_Best_Employee_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Best_Employee/Award_Best_Employee_2x.webp";

// Participation
import Award_Participation_1x from "./../assets/AwardsPage/Logos/Award_Participation/Award_Participation_1x.webp";
import Award_Participation_2x from "./../assets/AwardsPage/Logos/Award_Participation/Award_Participation_2x.webp";
import Award_Participation_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Participation/Award_Participation_1x.webp";
import Award_Participation_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Participation/Award_Participation_2x.webp";

// Screenshots
// 1
//#region AppsForAsia2013 - Thumbnails
import AppsForAsia2013Photo1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo1/Photo1_1x.webp";
import AppsForAsia2013Photo1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo1/Photo1_2x.webp";
import AppsForAsia2013Photo1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo1/Photo1_1x.webp";
import AppsForAsia2013Photo1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo1/Photo1_2x.webp";

import AppsForAsia2013Photo2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo2/Photo2_1x.webp";
import AppsForAsia2013Photo2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo2/Photo2_2x.webp";
import AppsForAsia2013Photo2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo2/Photo2_1x.webp";
import AppsForAsia2013Photo2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo2/Photo2_2x.webp";

import AppsForAsia2013Photo3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo3/Photo3_1x.webp";
import AppsForAsia2013Photo3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo3/Photo3_2x.webp";
import AppsForAsia2013Photo3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo3/Photo3_1x.webp";
import AppsForAsia2013Photo3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo3/Photo3_2x.webp";

import AppsForAsia2013Photo4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo4/Photo4_1x.webp";
import AppsForAsia2013Photo4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo4/Photo4_2x.webp";
import AppsForAsia2013Photo4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo4/Photo4_1x.webp";
import AppsForAsia2013Photo4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo4/Photo4_2x.webp";

import AppsForAsia2013Photo5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo5/Photo5_1x.webp";
import AppsForAsia2013Photo5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo5/Photo5_2x.webp";
import AppsForAsia2013Photo5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo5/Photo5_1x.webp";
import AppsForAsia2013Photo5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo5/Photo5_2x.webp";

import AppsForAsia2013Photo6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo6/Photo6_1x.webp";
import AppsForAsia2013Photo6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo6/Photo6_2x.webp";
import AppsForAsia2013Photo6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo6/Photo6_1x.webp";
import AppsForAsia2013Photo6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo6/Photo6_2x.webp";

import AppsForAsia2013Photo7_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo7/Photo7_1x.webp";
import AppsForAsia2013Photo7_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo7/Photo7_2x.webp";
import AppsForAsia2013Photo7_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo7/Photo7_1x.webp";
import AppsForAsia2013Photo7_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo7/Photo7_2x.webp";

import AppsForAsia2013Photo8_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo8/Photo8_1x.webp";
import AppsForAsia2013Photo8_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo8/Photo8_2x.webp";
import AppsForAsia2013Photo8_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo8/Photo8_1x.webp";
import AppsForAsia2013Photo8_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo8/Photo8_2x.webp";

import AppsForAsia2013Photo9_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo9/Photo9_1x.webp";
import AppsForAsia2013Photo9_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo9/Photo9_2x.webp";
import AppsForAsia2013Photo9_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo9/Photo9_1x.webp";
import AppsForAsia2013Photo9_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo9/Photo9_2x.webp";

import AppsForAsia2013Photo10_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo10/Photo10_1x.webp";
import AppsForAsia2013Photo10_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/Photo10/Photo10_2x.webp";
import AppsForAsia2013Photo10_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo10/Photo10_1x.webp";
import AppsForAsia2013Photo10_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/1AppsForAsia2013/0Mobile/Photo10/Photo10_2x.webp";
//#endregion

// 2
//#region BestEmployee - Thumbnails
import BestEmployeePhoto1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo1/Photo1_1x.webp";
import BestEmployeePhoto1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo1/Photo1_2x.webp";
import BestEmployeePhoto1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo1/Photo1_1x.webp";
import BestEmployeePhoto1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo1/Photo1_2x.webp";

import BestEmployeePhoto2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo2/Photo2_1x.webp";
import BestEmployeePhoto2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo2/Photo2_2x.webp";
import BestEmployeePhoto2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo2/Photo2_1x.webp";
import BestEmployeePhoto2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo2/Photo2_2x.webp";

import BestEmployeePhoto3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo3/Photo3_1x.webp";
import BestEmployeePhoto3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo3/Photo3_2x.webp";
import BestEmployeePhoto3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo3/Photo3_1x.webp";
import BestEmployeePhoto3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo3/Photo3_2x.webp";

import BestEmployeePhoto4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo4/Photo4_1x.webp";
import BestEmployeePhoto4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo4/Photo4_2x.webp";
import BestEmployeePhoto4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo4/Photo4_1x.webp";
import BestEmployeePhoto4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo4/Photo4_2x.webp";

import BestEmployeePhoto5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo5/Photo5_1x.webp";
import BestEmployeePhoto5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo5/Photo5_2x.webp";
import BestEmployeePhoto5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo5/Photo5_1x.webp";
import BestEmployeePhoto5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo5/Photo5_2x.webp";

import BestEmployeePhoto6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo6/Photo6_1x.webp";
import BestEmployeePhoto6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo6/Photo6_2x.webp";
import BestEmployeePhoto6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo6/Photo6_1x.webp";
import BestEmployeePhoto6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo6/Photo6_2x.webp";

import BestEmployeePhoto7_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo7/Photo7_1x.webp";
import BestEmployeePhoto7_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo7/Photo7_2x.webp";
import BestEmployeePhoto7_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo7/Photo7_1x.webp";
import BestEmployeePhoto7_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo7/Photo7_2x.webp";

import BestEmployeePhoto8_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo8/Photo8_1x.webp";
import BestEmployeePhoto8_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo8/Photo8_2x.webp";
import BestEmployeePhoto8_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo8/Photo8_1x.webp";
import BestEmployeePhoto8_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo8/Photo8_2x.webp";

import BestEmployeePhoto9_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo9/Photo9_1x.webp";
import BestEmployeePhoto9_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/Photo9/Photo9_2x.webp";
import BestEmployeePhoto9_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo9/Photo9_1x.webp";
import BestEmployeePhoto9_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/2BestEmpAward2013/0Mobile/Photo9/Photo9_2x.webp";
//#endregion

// 3
//#region AppFest - Thumbnails
import AppFestPhoto1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo1/Photo1_1x.webp";
import AppFestPhoto1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo1/Photo1_2x.webp";
import AppFestPhoto1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo1/Photo1_1x.webp";
import AppFestPhoto1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo1/Photo1_2x.webp";

import AppFestPhoto2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo2/Photo2_1x.webp";
import AppFestPhoto2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo2/Photo2_2x.webp";
import AppFestPhoto2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo2/Photo2_1x.webp";
import AppFestPhoto2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo2/Photo2_2x.webp";

import AppFestPhoto3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo3/Photo3_1x.webp";
import AppFestPhoto3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo3/Photo3_2x.webp";
import AppFestPhoto3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo3/Photo3_1x.webp";
import AppFestPhoto3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo3/Photo3_2x.webp";

import AppFestPhoto4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo4/Photo4_1x.webp";
import AppFestPhoto4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo4/Photo4_2x.webp";
import AppFestPhoto4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo4/Photo4_1x.webp";
import AppFestPhoto4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo4/Photo4_2x.webp";

import AppFestPhoto5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo5/Photo5_1x.webp";
import AppFestPhoto5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo5/Photo5_2x.webp";
import AppFestPhoto5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo5/Photo5_1x.webp";
import AppFestPhoto5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo5/Photo5_2x.webp";

import AppFestPhoto6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo6/Photo6_1x.webp";
import AppFestPhoto6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/Photo6/Photo6_2x.webp";
import AppFestPhoto6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo6/Photo6_1x.webp";
import AppFestPhoto6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/3WinnerAppFestPune2013/0Mobile/Photo6/Photo6_2x.webp";
//#endregion

// 4
//#region CTechnoWar10 - Thumbnails
import CTechnoWar10Photo1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo1/Photo1_1x.webp";
import CTechnoWar10Photo1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo1/Photo1_2x.webp";
import CTechnoWar10Photo1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo1/Photo1_1x.webp";
import CTechnoWar10Photo1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo1/Photo1_2x.webp";

import CTechnoWar10Photo2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo2/Photo2_1x.webp";
import CTechnoWar10Photo2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo2/Photo2_2x.webp";
import CTechnoWar10Photo2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo2/Photo2_1x.webp";
import CTechnoWar10Photo2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo2/Photo2_2x.webp";

import CTechnoWar10Photo3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo3/Photo3_1x.webp";
import CTechnoWar10Photo3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo3/Photo3_2x.webp";
import CTechnoWar10Photo3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo3/Photo3_1x.webp";
import CTechnoWar10Photo3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo3/Photo3_2x.webp";

import CTechnoWar10Photo4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo4/Photo4_1x.webp";
import CTechnoWar10Photo4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo4/Photo4_2x.webp";
import CTechnoWar10Photo4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo4/Photo4_1x.webp";
import CTechnoWar10Photo4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo4/Photo4_2x.webp";

import CTechnoWar10Photo5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo5/Photo5_1x.webp";
import CTechnoWar10Photo5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo5/Photo5_2x.webp";
import CTechnoWar10Photo5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo5/Photo5_1x.webp";
import CTechnoWar10Photo5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo5/Photo5_2x.webp";

import CTechnoWar10Photo6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo6/Photo6_1x.webp";
import CTechnoWar10Photo6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/Photo6/Photo6_2x.webp";
import CTechnoWar10Photo6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo6/Photo6_1x.webp";
import CTechnoWar10Photo6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/4FirstPrizeCTechnoWar2010/0Mobile/Photo6/Photo6_2x.webp";
//#endregion

// 5
//#region PrincipalAppreciation - Thumbnails
import PrincipalAppreciationPhoto1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo1/Photo1_1x.webp";
import PrincipalAppreciationPhoto1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo1/Photo1_2x.webp";
import PrincipalAppreciationPhoto1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo1/Photo1_1x.webp";
import PrincipalAppreciationPhoto1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo1/Photo1_2x.webp";

import PrincipalAppreciationPhoto2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo2/Photo2_1x.webp";
import PrincipalAppreciationPhoto2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo2/Photo2_2x.webp";
import PrincipalAppreciationPhoto2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo2/Photo2_1x.webp";
import PrincipalAppreciationPhoto2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo2/Photo2_2x.webp";

import PrincipalAppreciationPhoto3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo3/Photo3_1x.webp";
import PrincipalAppreciationPhoto3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo3/Photo3_2x.webp";
import PrincipalAppreciationPhoto3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo3/Photo3_1x.webp";
import PrincipalAppreciationPhoto3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo3/Photo3_2x.webp";

import PrincipalAppreciationPhoto4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo4/Photo4_1x.webp";
import PrincipalAppreciationPhoto4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo4/Photo4_2x.webp";
import PrincipalAppreciationPhoto4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo4/Photo4_1x.webp";
import PrincipalAppreciationPhoto4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo4/Photo4_2x.webp";

import PrincipalAppreciationPhoto5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo5/Photo5_1x.webp";
import PrincipalAppreciationPhoto5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo5/Photo5_2x.webp";
import PrincipalAppreciationPhoto5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo5/Photo5_1x.webp";
import PrincipalAppreciationPhoto5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo5/Photo5_2x.webp";

import PrincipalAppreciationPhoto6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo6/Photo6_1x.webp";
import PrincipalAppreciationPhoto6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo6/Photo6_2x.webp";
import PrincipalAppreciationPhoto6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo6/Photo6_1x.webp";
import PrincipalAppreciationPhoto6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo6/Photo6_2x.webp";

import PrincipalAppreciationPhoto7_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo7/Photo7_1x.webp";
import PrincipalAppreciationPhoto7_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo7/Photo7_2x.webp";
import PrincipalAppreciationPhoto7_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo7/Photo7_1x.webp";
import PrincipalAppreciationPhoto7_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo7/Photo7_2x.webp";

import PrincipalAppreciationPhoto8_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo8/Photo8_1x.webp";
import PrincipalAppreciationPhoto8_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/Photo8/Photo8_2x.webp";
import PrincipalAppreciationPhoto8_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo8/Photo8_1x.webp";
import PrincipalAppreciationPhoto8_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/5PrincipalAppreciationQuizTechnoWar2011/0Mobile/Photo8/Photo8_2x.webp";
//#endregion

// 6
//#region PrincipalAppreciation - Thumbnails
import ProjectUtsav2010Photo1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo1/Photo1_1x.webp";
import ProjectUtsav2010Photo1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo1/Photo1_2x.webp";
import ProjectUtsav2010Photo1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo1/Photo1_1x.webp";
import ProjectUtsav2010Photo1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo1/Photo1_2x.webp";

import ProjectUtsav2010Photo2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo2/Photo2_1x.webp";
import ProjectUtsav2010Photo2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo2/Photo2_2x.webp";
import ProjectUtsav2010Photo2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo2/Photo2_1x.webp";
import ProjectUtsav2010Photo2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo2/Photo2_2x.webp";

import ProjectUtsav2010Photo3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo3/Photo3_1x.webp";
import ProjectUtsav2010Photo3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo3/Photo3_2x.webp";
import ProjectUtsav2010Photo3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo3/Photo3_1x.webp";
import ProjectUtsav2010Photo3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo3/Photo3_2x.webp";

import ProjectUtsav2010Photo4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo4/Photo4_1x.webp";
import ProjectUtsav2010Photo4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo4/Photo4_2x.webp";
import ProjectUtsav2010Photo4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo4/Photo4_1x.webp";
import ProjectUtsav2010Photo4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo4/Photo4_2x.webp";

import ProjectUtsav2010Photo5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo5/Photo5_1x.webp";
import ProjectUtsav2010Photo5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo5/Photo5_2x.webp";
import ProjectUtsav2010Photo5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo5/Photo5_1x.webp";
import ProjectUtsav2010Photo5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo5/Photo5_2x.webp";

import ProjectUtsav2010Photo6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo6/Photo6_1x.webp";
import ProjectUtsav2010Photo6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo6/Photo6_2x.webp";
import ProjectUtsav2010Photo6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo6/Photo6_1x.webp";
import ProjectUtsav2010Photo6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo6/Photo6_2x.webp";

import ProjectUtsav2010Photo7_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo7/Photo7_1x.webp";
import ProjectUtsav2010Photo7_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo7/Photo7_2x.webp";
import ProjectUtsav2010Photo7_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo7/Photo7_1x.webp";
import ProjectUtsav2010Photo7_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo7/Photo7_2x.webp";

import ProjectUtsav2010Photo8_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo8/Photo8_1x.webp";
import ProjectUtsav2010Photo8_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo8/Photo8_2x.webp";
import ProjectUtsav2010Photo8_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo8/Photo8_1x.webp";
import ProjectUtsav2010Photo8_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo8/Photo8_2x.webp";

import ProjectUtsav2010Photo9_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo9/Photo9_1x.webp";
import ProjectUtsav2010Photo9_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/Photo9/Photo9_2x.webp";
import ProjectUtsav2010Photo9_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo9/Photo9_1x.webp";
import ProjectUtsav2010Photo9_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/6FirstPrizeProjectCompetitionUtsav2010/0Mobile/Photo9/Photo9_2x.webp";
//#endregion

// 7
//#region JuryMIT24 - Thumbnails
import JuryMIT24Photo1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo1/Photo1_1x.webp";
import JuryMIT24Photo1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo1/Photo1_2x.webp";
import JuryMIT24Photo1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo1/Photo1_1x.webp";
import JuryMIT24Photo1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo1/Photo1_2x.webp";

import JuryMIT24Photo2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo2/Photo2_1x.webp";
import JuryMIT24Photo2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo2/Photo2_2x.webp";
import JuryMIT24Photo2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo2/Photo2_1x.webp";
import JuryMIT24Photo2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo2/Photo2_2x.webp";

import JuryMIT24Photo3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo3/Photo3_1x.webp";
import JuryMIT24Photo3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo3/Photo3_2x.webp";
import JuryMIT24Photo3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo3/Photo3_1x.webp";
import JuryMIT24Photo3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo3/Photo3_2x.webp";

import JuryMIT24Photo4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo4/Photo4_1x.webp";
import JuryMIT24Photo4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo4/Photo4_2x.webp";
import JuryMIT24Photo4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo4/Photo4_1x.webp";
import JuryMIT24Photo4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo4/Photo4_2x.webp";

import JuryMIT24Photo5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo5/Photo5_1x.webp";
import JuryMIT24Photo5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo5/Photo5_2x.webp";
import JuryMIT24Photo5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo5/Photo5_1x.webp";
import JuryMIT24Photo5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo5/Photo5_2x.webp";

import JuryMIT24Photo6_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo6/Photo6_1x.webp";
import JuryMIT24Photo6_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo6/Photo6_2x.webp";
import JuryMIT24Photo6_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo6/Photo6_1x.webp";
import JuryMIT24Photo6_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo6/Photo6_2x.webp";

import JuryMIT24Photo7_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo7/Photo7_1x.webp";
import JuryMIT24Photo7_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/Photo7/Photo7_2x.webp";
import JuryMIT24Photo7_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo7/Photo7_1x.webp";
import JuryMIT24Photo7_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/7JuryAtHackthonMITPune2024/0Mobile/Photo7/Photo7_2x.webp";
//#endregion

// 8
//#region JuryCummins24 - Thumbnails
import JuryCummins24Photo1_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo1/Photo1_1x.webp";
import JuryCummins24Photo1_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo1/Photo1_2x.webp";
import JuryCummins24Photo1_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo1/Photo1_1x.webp";
import JuryCummins24Photo1_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo1/Photo1_2x.webp";

import JuryCummins24Photo2_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo2/Photo2_1x.webp";
import JuryCummins24Photo2_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo2/Photo2_2x.webp";
import JuryCummins24Photo2_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo2/Photo2_1x.webp";
import JuryCummins24Photo2_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo2/Photo2_2x.webp";

import JuryCummins24Photo3_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo3/Photo3_1x.webp";
import JuryCummins24Photo3_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo3/Photo3_2x.webp";
import JuryCummins24Photo3_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo3/Photo3_1x.webp";
import JuryCummins24Photo3_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo3/Photo3_2x.webp";

import JuryCummins24Photo4_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo4/Photo4_1x.webp";
import JuryCummins24Photo4_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo4/Photo4_2x.webp";
import JuryCummins24Photo4_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo4/Photo4_1x.webp";
import JuryCummins24Photo4_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo4/Photo4_2x.webp";

import JuryCummins24Photo5_1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo5/Photo5_1x.webp";
import JuryCummins24Photo5_2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/Photo5/Photo5_2x.webp";
import JuryCummins24Photo5_M1x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo5/Photo5_1x.webp";
import JuryCummins24Photo5_M2x from "./../assets/MemoriesPage/ThumbnailsInListPage/8JuryAtHackthonCumminsPune2024/0Mobile/Photo5/Photo5_2x.webp";
//#endregion

import WizardComponent from "../components/Wizard/Wizard";

import { useEffect } from "react";

export default function MemoriesPage() {
  async function setPageHitsOnDB() {
    const url =
      "https://jagdishchopde-profile-default-rtdb.firebaseio.com/dataMemoriesPage.json";
    try {
      const response = await fetch(url);
      if (response.ok) {
        const json = await response.json();

        fetch(url, {
          method: "PUT",
          body: JSON.stringify({ pageHits: +json.pageHits + 1 }),
        });
      }
    } catch (error) {
      // console.error(error.message);
    }
  }

  useEffect(() => {
    setPageHitsOnDB();
  }, []);

  // Set Page Data
  const data = [
    // 1
    {
      id: 1,
      tag: "2013",
      card: {
        date: "5 MAY 2013",
        title:
          "1st Prize Winner of Apps For Asia - Microsoft at ADB Summit 2013, Delhi, India",
        subText:
          "Delhi, India | Project Competition cum Exhibition - 46th Annual Meeting of The Board of Governors, Asian Development Bank Summit 2013",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "Frist Prize Logo",
        links: [
          {
            id: 1,
            linkTitle: "Check out about this in Business Today's news article",
            hyperlink:
              "https://www.businesstoday.in/technology/news/story/made-for-maharashtra-apps-showcased-at-adb-summit-41052-2013-05-06",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: AppsForAsia2013Photo1_1x,
          image2x: AppsForAsia2013Photo1_2x,
          imageM1x: AppsForAsia2013Photo1_M1x,
          imageM2x: AppsForAsia2013Photo1_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 2,
          image1x: AppsForAsia2013Photo2_1x,
          image2x: AppsForAsia2013Photo2_2x,
          imageM1x: AppsForAsia2013Photo2_M1x,
          imageM2x: AppsForAsia2013Photo2_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 3,
          image1x: AppsForAsia2013Photo3_1x,
          image2x: AppsForAsia2013Photo3_2x,
          imageM1x: AppsForAsia2013Photo3_M1x,
          imageM2x: AppsForAsia2013Photo3_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 4,
          image1x: AppsForAsia2013Photo4_1x,
          image2x: AppsForAsia2013Photo4_2x,
          imageM1x: AppsForAsia2013Photo4_M1x,
          imageM2x: AppsForAsia2013Photo4_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 5,
          image1x: AppsForAsia2013Photo5_1x,
          image2x: AppsForAsia2013Photo5_2x,
          imageM1x: AppsForAsia2013Photo5_M1x,
          imageM2x: AppsForAsia2013Photo5_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 6,
          image1x: AppsForAsia2013Photo6_1x,
          image2x: AppsForAsia2013Photo6_2x,
          imageM1x: AppsForAsia2013Photo6_M1x,
          imageM2x: AppsForAsia2013Photo6_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 7,
          image1x: AppsForAsia2013Photo7_1x,
          image2x: AppsForAsia2013Photo7_2x,
          imageM1x: AppsForAsia2013Photo7_M1x,
          imageM2x: AppsForAsia2013Photo7_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 8,
          image1x: AppsForAsia2013Photo8_1x,
          image2x: AppsForAsia2013Photo8_2x,
          imageM1x: AppsForAsia2013Photo8_M1x,
          imageM2x: AppsForAsia2013Photo8_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 9,
          image1x: AppsForAsia2013Photo9_1x,
          image2x: AppsForAsia2013Photo9_2x,
          imageM1x: AppsForAsia2013Photo9_M1x,
          imageM2x: AppsForAsia2013Photo9_M2x,
          alt: "Apps For Asia Screenshot",
        },
        {
          id: 10,
          image1x: AppsForAsia2013Photo10_1x,
          image2x: AppsForAsia2013Photo10_2x,
          imageM1x: AppsForAsia2013Photo10_M1x,
          imageM2x: AppsForAsia2013Photo10_M2x,
          alt: "Apps For Asia Screenshot",
        },
      ],
    },
    // 2
    {
      id: 2,
      tag: "2013",
      card: {
        date: "DEC 2013",
        title: "Best Employee Award",
        subText:
          "Nashik | Winjit One World - WOW - Winjit Technologies Pvt. Ltd., Nasik.",
        image1x: Award_Best_Employee_1x,
        image2x: Award_Best_Employee_2x,
        imageM1x: Award_Best_Employee_M1x,
        imageM2x: Award_Best_Employee_M2x,
        alt: "Best Employee Award Logo",
      },
      images: [
        {
          id: 1,
          image1x: BestEmployeePhoto1_1x,
          image2x: BestEmployeePhoto1_2x,
          imageM1x: BestEmployeePhoto1_M1x,
          imageM2x: BestEmployeePhoto1_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 7,
          image1x: BestEmployeePhoto7_1x,
          image2x: BestEmployeePhoto7_2x,
          imageM1x: BestEmployeePhoto7_M1x,
          imageM2x: BestEmployeePhoto7_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 2,
          image1x: BestEmployeePhoto2_1x,
          image2x: BestEmployeePhoto2_2x,
          imageM1x: BestEmployeePhoto2_M1x,
          imageM2x: BestEmployeePhoto2_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 3,
          image1x: BestEmployeePhoto3_1x,
          image2x: BestEmployeePhoto3_2x,
          imageM1x: BestEmployeePhoto3_M1x,
          imageM2x: BestEmployeePhoto3_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 4,
          image1x: BestEmployeePhoto4_1x,
          image2x: BestEmployeePhoto4_2x,
          imageM1x: BestEmployeePhoto4_M1x,
          imageM2x: BestEmployeePhoto4_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 5,
          image1x: BestEmployeePhoto5_1x,
          image2x: BestEmployeePhoto5_2x,
          imageM1x: BestEmployeePhoto5_M1x,
          imageM2x: BestEmployeePhoto5_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 6,
          image1x: BestEmployeePhoto6_1x,
          image2x: BestEmployeePhoto6_2x,
          imageM1x: BestEmployeePhoto6_M1x,
          imageM2x: BestEmployeePhoto6_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 8,
          image1x: BestEmployeePhoto8_1x,
          image2x: BestEmployeePhoto8_2x,
          imageM1x: BestEmployeePhoto8_M1x,
          imageM2x: BestEmployeePhoto8_M2x,
          alt: "Best Employee Award Screenshot",
        },
        {
          id: 9,
          image1x: BestEmployeePhoto9_1x,
          image2x: BestEmployeePhoto9_2x,
          imageM1x: BestEmployeePhoto9_M1x,
          imageM2x: BestEmployeePhoto9_M2x,
          alt: "Best Employee Award Screenshot",
        },
      ],
    },
    // 3
    {
      id: 3,
      tag: "2013",
      card: {
        date: "MAR 2013",
        title:
          "1st Prize Winner of AppFest at Microsoft TechEd 2013, Pune, India",
        subText: "Pune | Project Competition - Microsoft TechEd 2013",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "Frist Prize Award Logo",
      },
      images: [
        {
          id: 1,
          image1x: AppFestPhoto1_1x,
          image2x: AppFestPhoto1_2x,
          imageM1x: AppFestPhoto1_M1x,
          imageM2x: AppFestPhoto1_M2x,
          alt: "AppFest Screenshot",
        },
        {
          id: 2,
          image1x: AppFestPhoto2_1x,
          image2x: AppFestPhoto2_2x,
          imageM1x: AppFestPhoto2_M1x,
          imageM2x: AppFestPhoto2_M2x,
          alt: "AppFest Screenshot",
        },
        {
          id: 3,
          image1x: AppFestPhoto3_1x,
          image2x: AppFestPhoto3_2x,
          imageM1x: AppFestPhoto3_M1x,
          imageM2x: AppFestPhoto3_M2x,
          alt: "AppFest Screenshot",
        },
        {
          id: 4,
          image1x: AppFestPhoto4_1x,
          image2x: AppFestPhoto4_2x,
          imageM1x: AppFestPhoto4_M1x,
          imageM2x: AppFestPhoto4_M2x,
          alt: "AppFest Screenshot",
        },
        {
          id: 5,
          image1x: AppFestPhoto5_1x,
          image2x: AppFestPhoto5_2x,
          imageM1x: AppFestPhoto5_M1x,
          imageM2x: AppFestPhoto5_M2x,
          alt: "AppFest Screenshot",
        },
        {
          id: 6,
          image1x: AppFestPhoto6_1x,
          image2x: AppFestPhoto6_2x,
          imageM1x: AppFestPhoto6_M1x,
          imageM2x: AppFestPhoto6_M2x,
          alt: "AppFest Screenshot",
        },
      ],
    },
    // 4
    {
      id: 4,
      tag: "2010",
      card: {
        date: "14 sep 2010",
        title:
          "1st Prize Winner in C-Programming Inter College Competition - TechnoWar ‘10",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "Frist Prize Award Logo",
      },
      images: [
        {
          id: 1,
          image1x: CTechnoWar10Photo1_1x,
          image2x: CTechnoWar10Photo1_2x,
          imageM1x: CTechnoWar10Photo1_M1x,
          imageM2x: CTechnoWar10Photo1_M2x,
          alt: "1st Prize Winner in C-Programming Screenshot",
        },
        {
          id: 2,
          image1x: CTechnoWar10Photo2_1x,
          image2x: CTechnoWar10Photo2_2x,
          imageM1x: CTechnoWar10Photo2_M1x,
          imageM2x: CTechnoWar10Photo2_M2x,
          alt: "1st Prize Winner in C-Programming Screenshot",
        },
        {
          id: 3,
          image1x: CTechnoWar10Photo3_1x,
          image2x: CTechnoWar10Photo3_2x,
          imageM1x: CTechnoWar10Photo3_M1x,
          imageM2x: CTechnoWar10Photo3_M2x,
          alt: "1st Prize Winner in C-Programming Screenshot",
        },
        {
          id: 4,
          image1x: CTechnoWar10Photo4_1x,
          image2x: CTechnoWar10Photo4_2x,
          imageM1x: CTechnoWar10Photo4_M1x,
          imageM2x: CTechnoWar10Photo4_M2x,
          alt: "1st Prize Winner in C-Programming Screenshot",
        },
        {
          id: 5,
          image1x: CTechnoWar10Photo5_1x,
          image2x: CTechnoWar10Photo5_2x,
          imageM1x: CTechnoWar10Photo5_M1x,
          imageM2x: CTechnoWar10Photo5_M2x,
          alt: "1st Prize Winner in C-Programming Screenshot",
        },
        {
          id: 6,
          image1x: CTechnoWar10Photo6_1x,
          image2x: CTechnoWar10Photo6_2x,
          imageM1x: CTechnoWar10Photo6_M1x,
          imageM2x: CTechnoWar10Photo6_M2x,
          alt: "1st Prize Winner in C-Programming Screenshot",
        },
      ],
    },
    // 5
    {
      id: 5,
      tag: "2011",
      card: {
        date: "14 sep 2011",
        title:
          "Got Appreciation from Principal for Designing & Developing an Online Quiz Management System for Technical Event TechnoWar '11",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "Frist Prize Award Logo",
      },
      images: [
        {
          id: 1,
          image1x: PrincipalAppreciationPhoto1_1x,
          image2x: PrincipalAppreciationPhoto1_2x,
          imageM1x: PrincipalAppreciationPhoto1_M1x,
          imageM2x: PrincipalAppreciationPhoto1_M2x,
          alt: "Appreciation from Principal Screenshot",
        },
        {
          id: 2,
          image1x: PrincipalAppreciationPhoto2_1x,
          image2x: PrincipalAppreciationPhoto2_2x,
          imageM1x: PrincipalAppreciationPhoto2_M1x,
          imageM2x: PrincipalAppreciationPhoto2_M2x,
          alt: "Appreciation from Principal Screenshot",
        },
        {
          id: 3,
          image1x: PrincipalAppreciationPhoto3_1x,
          image2x: PrincipalAppreciationPhoto3_2x,
          imageM1x: PrincipalAppreciationPhoto3_M1x,
          imageM2x: PrincipalAppreciationPhoto3_M2x,
          alt: "Appreciation from Principal Screenshot",
        },
        {
          id: 4,
          image1x: PrincipalAppreciationPhoto4_1x,
          image2x: PrincipalAppreciationPhoto4_2x,
          imageM1x: PrincipalAppreciationPhoto4_M1x,
          imageM2x: PrincipalAppreciationPhoto4_M2x,
          alt: "Appreciation from Principal Screenshot",
        },
        {
          id: 5,
          image1x: PrincipalAppreciationPhoto5_1x,
          image2x: PrincipalAppreciationPhoto5_2x,
          imageM1x: PrincipalAppreciationPhoto5_M1x,
          imageM2x: PrincipalAppreciationPhoto5_M2x,
          alt: "Appreciation from Principal Screenshot",
        },
        {
          id: 6,
          image1x: PrincipalAppreciationPhoto6_1x,
          image2x: PrincipalAppreciationPhoto6_2x,
          imageM1x: PrincipalAppreciationPhoto6_M1x,
          imageM2x: PrincipalAppreciationPhoto6_M2x,
          alt: "Appreciation from Principal Screenshot",
        },

        {
          id: 7,
          image1x: PrincipalAppreciationPhoto7_1x,
          image2x: PrincipalAppreciationPhoto7_2x,
          imageM1x: PrincipalAppreciationPhoto7_M1x,
          imageM2x: PrincipalAppreciationPhoto7_M2x,
          alt: "Appreciation from Principal Screenshot",
        },

        {
          id: 8,
          image1x: PrincipalAppreciationPhoto8_1x,
          image2x: PrincipalAppreciationPhoto8_2x,
          imageM1x: PrincipalAppreciationPhoto8_M1x,
          imageM2x: PrincipalAppreciationPhoto8_M2x,
          alt: "Appreciation from Principal Screenshot",
        },
      ],
    },
    // 6
    {
      id: 6,
      tag: "2010",
      card: {
        date: "jan 2010",
        title:
          "First Prize in State Level Software Project Competition cum Exhibition - Utsav '10",
        subText: "Nashik | Utsav ‘10 - MET College of Engineering",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "Frist Prize Award Logo",
      },
      images: [
        {
          id: 1,
          image1x: ProjectUtsav2010Photo1_1x,
          image2x: ProjectUtsav2010Photo1_2x,
          imageM1x: ProjectUtsav2010Photo1_M1x,
          imageM2x: ProjectUtsav2010Photo1_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
        {
          id: 2,
          image1x: ProjectUtsav2010Photo2_1x,
          image2x: ProjectUtsav2010Photo2_2x,
          imageM1x: ProjectUtsav2010Photo2_M1x,
          imageM2x: ProjectUtsav2010Photo2_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
        {
          id: 3,
          image1x: ProjectUtsav2010Photo3_1x,
          image2x: ProjectUtsav2010Photo3_2x,
          imageM1x: ProjectUtsav2010Photo3_M1x,
          imageM2x: ProjectUtsav2010Photo3_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
        {
          id: 4,
          image1x: ProjectUtsav2010Photo4_1x,
          image2x: ProjectUtsav2010Photo4_2x,
          imageM1x: ProjectUtsav2010Photo4_M1x,
          imageM2x: ProjectUtsav2010Photo4_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
        {
          id: 5,
          image1x: ProjectUtsav2010Photo5_1x,
          image2x: ProjectUtsav2010Photo5_2x,
          imageM1x: ProjectUtsav2010Photo5_M1x,
          imageM2x: ProjectUtsav2010Photo5_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
        {
          id: 6,
          image1x: ProjectUtsav2010Photo6_1x,
          image2x: ProjectUtsav2010Photo6_2x,
          imageM1x: ProjectUtsav2010Photo6_M1x,
          imageM2x: ProjectUtsav2010Photo6_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },

        {
          id: 7,
          image1x: ProjectUtsav2010Photo7_1x,
          image2x: ProjectUtsav2010Photo7_2x,
          imageM1x: ProjectUtsav2010Photo7_M1x,
          imageM2x: ProjectUtsav2010Photo7_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },

        {
          id: 8,
          image1x: ProjectUtsav2010Photo8_1x,
          image2x: ProjectUtsav2010Photo8_2x,
          imageM1x: ProjectUtsav2010Photo8_M1x,
          imageM2x: ProjectUtsav2010Photo8_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
        {
          id: 9,
          image1x: ProjectUtsav2010Photo9_1x,
          image2x: ProjectUtsav2010Photo9_2x,
          imageM1x: ProjectUtsav2010Photo9_M1x,
          imageM2x: ProjectUtsav2010Photo9_M2x,
          alt: "Project Competition Utsav 10 Screenshot",
        },
      ],
    },
    // 7
    {
      id: 7,
      tag: "2024",
      card: {
        date: "21 MAR 2024",
        title: "Jury at MIT Hackathon, MIT College of Engineering, Pune",
        subText: "Pune | MIT World Peace University, Pune",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation Jury Logo",
      },
      images: [
        {
          id: 2,
          image1x: JuryMIT24Photo2_1x,
          image2x: JuryMIT24Photo2_2x,
          imageM1x: JuryMIT24Photo2_M1x,
          imageM2x: JuryMIT24Photo2_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 1,
          image1x: JuryMIT24Photo1_1x,
          image2x: JuryMIT24Photo1_2x,
          imageM1x: JuryMIT24Photo1_M1x,
          imageM2x: JuryMIT24Photo1_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 3,
          image1x: JuryMIT24Photo3_1x,
          image2x: JuryMIT24Photo3_2x,
          imageM1x: JuryMIT24Photo3_M1x,
          imageM2x: JuryMIT24Photo3_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 4,
          image1x: JuryMIT24Photo4_1x,
          image2x: JuryMIT24Photo4_2x,
          imageM1x: JuryMIT24Photo4_M1x,
          imageM2x: JuryMIT24Photo4_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 5,
          image1x: JuryMIT24Photo5_1x,
          image2x: JuryMIT24Photo5_2x,
          imageM1x: JuryMIT24Photo5_M1x,
          imageM2x: JuryMIT24Photo5_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 6,
          image1x: JuryMIT24Photo6_1x,
          image2x: JuryMIT24Photo6_2x,
          imageM1x: JuryMIT24Photo6_M1x,
          imageM2x: JuryMIT24Photo6_M2x,
          alt: "Jury Screenshot",
        },

        {
          id: 7,
          image1x: JuryMIT24Photo7_1x,
          image2x: JuryMIT24Photo7_2x,
          imageM1x: JuryMIT24Photo7_M1x,
          imageM2x: JuryMIT24Photo7_M2x,
          alt: "Jury Screenshot",
        },
      ],
    },
    // 8
    {
      id: 8,
      tag: "2024",
      card: {
        date: "4 APR 2024",
        title:
          "Jury at Hackathon, Cummins College of Engineering for Women, Pune",
        subText: "Pune | Cummins College of Engineering for Women, Pune",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation Jury Logo",
      },
      images: [
        {
          id: 5,
          image1x: JuryCummins24Photo5_1x,
          image2x: JuryCummins24Photo5_2x,
          imageM1x: JuryCummins24Photo5_M1x,
          imageM2x: JuryCummins24Photo5_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 1,
          image1x: JuryCummins24Photo1_1x,
          image2x: JuryCummins24Photo1_2x,
          imageM1x: JuryCummins24Photo1_M1x,
          imageM2x: JuryCummins24Photo1_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 2,
          image1x: JuryCummins24Photo2_1x,
          image2x: JuryCummins24Photo2_2x,
          imageM1x: JuryCummins24Photo2_M1x,
          imageM2x: JuryCummins24Photo2_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 3,
          image1x: JuryCummins24Photo3_1x,
          image2x: JuryCummins24Photo3_2x,
          imageM1x: JuryCummins24Photo3_M1x,
          imageM2x: JuryCummins24Photo3_M2x,
          alt: "Jury Screenshot",
        },
        {
          id: 4,
          image1x: JuryCummins24Photo4_1x,
          image2x: JuryCummins24Photo4_2x,
          imageM1x: JuryCummins24Photo4_M1x,
          imageM2x: JuryCummins24Photo4_M2x,
          alt: "Jury Screenshot",
        },
      ],
    },
  ];

  return <WizardComponent pageTitle="Achievements & Memories" data={data} />;
}
